/** Total text length in root using the same rules as getCaretTextOffset (for clamping). */
export function getRootTextLength(root) {
  if (!root) return 0;
  const r = document.createRange();
  r.selectNodeContents(root);
  return r.toString().length;
}

/** Serialize caret as a character offset in root's text content (for undo/redo). */
export function getCaretTextOffset(root) {
  const sel = window.getSelection();
  if (!sel?.rangeCount || !root) return null;
  const range = sel.getRangeAt(0);
  if (!root.contains(range.startContainer)) return null;
  const pre = document.createRange();
  pre.selectNodeContents(root);
  pre.setEnd(range.startContainer, range.startOffset);
  return pre.toString().length;
}

/** Restore caret from a text offset; clamps to document end. */
export function setCaretFromTextOffset(root, offset) {
  if (!root || offset == null || offset < 0) return;
  const sel = window.getSelection();
  let remaining = offset;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
  let n = walker.nextNode();
  while (n) {
    const len = n.textContent.length;
    if (remaining <= len) {
      const r = document.createRange();
      r.setStart(n, Math.min(remaining, len));
      r.collapse(true);
      sel.removeAllRanges();
      sel.addRange(r);
      return;
    }
    remaining -= len;
    n = walker.nextNode();
  }
  const r = document.createRange();
  r.selectNodeContents(root);
  r.collapse(false);
  sel.removeAllRanges();
  sel.addRange(r);
}
